import React, { ChangeEvent } from 'react';
import { useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';

import { GroupList } from './components';
import { Input, Button } from 'components';
import Icon from 'assets/icons';

import { useGroupsSidebarState, useGroupsSidebarDispatch } from 'context/GroupsSidebarContext';
import { useTranslation } from 'hooks';

import styles from './GroupsSidebar.module.scss';

export const GroupsSidebar = () => {
  /*
   * TODO
   * Extract logic for hiding sidebar
   */

  const isSettingsRoute = useRouteMatch({
    path: '/settings',
    exact: true,
    strict: true,
    sensitive: true,
  });

  if (isSettingsRoute) {
    return <></>;
  }

  return <GroupsSidebarContent />;
};

export const GroupsSidebarContent = () => {
  const { t } = useTranslation();
  const { open } = useGroupsSidebarState();
  const [search, setSearch] = React.useState('');
  const groupsSidebarDispatch = useGroupsSidebarDispatch();

  const toggleSidebar = React.useCallback(() => {
    groupsSidebarDispatch({ type: 'TOGGLE_SIDEBAR' });
  }, [groupsSidebarDispatch]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearchClear = () => {
    setSearch('');
  };

  return (
    <>
      <span
        className={classNames('hasTooltip tooltipBelowRight', styles.sidebarTrigger)}
        data-tooltip="Collaborators"
        onClick={toggleSidebar}
      >
        <Icon.PeopleList />
      </span>

      <div className={classNames(styles.overlay, open && styles.open)} onClick={toggleSidebar} />

      <aside
        className={classNames(styles.groupsSidebar, styles.container, open && styles.openDrawer)}
      >
        <span className={styles.searchClose} onClick={toggleSidebar}>
          <Icon.MenuClose />
        </span>

        <div className={styles.header}>
          <Input
            className={styles.memberSearch}
            icon={<Icon.Search className={styles.searchIcon} />}
            theme="Search"
            value={search}
            placeholder="Search for people"
            onChange={handleSearch}
          >
            {search && (
              <div className={styles.clear}>
                <Button onClick={onSearchClear} className={styles.clearLink} type="Chiclet">
                  {t('navigation-bar.search.clear-label')}
                </Button>
              </div>
            )}
          </Input>
        </div>

        <div className={styles.groups}>
          <GroupList search={search} />
        </div>
      </aside>
    </>
  );
};
